
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser } from "@/utils/index"
import { getAccountInfo, getMoreAccountInfo, getEDPLANPairCount, getCarfundMonitor} from "@/api/dashboard"
import ECP_EDP_DashboardNavigator from "@/components/cards/ECP_EDP_DashboardNavigator.vue"

import { getCSSVariableValue } from "@/assets/ts/_utils";

export default defineComponent({
  name: "accountinfo",
  components: {
    ECP_EDP_DashboardNavigator
  },
  data() {
    return { 
      user:{},
      summary1: {},
      isLoading:true,
      pt : "",
      isShowMore :  true,
      summary2: {},
      ccode : -1,
      edplanpairs : 0,
      maxUturn : 0,
      series : [0],
      loadingMonitor : false,
      carfundMonitor: {},
      packageType : ''
    }
  },
  mounted(){
      this.user = getCurrentUser();
      this.packageType = String(localStorage.getItem("pVaAcNkPaOgGeItRyEpAeL"));

      this.getPT();
      this.getAccountInfo();
      this.getEDPLANPairCountNow();
      
      console.log(this.packageType);
      if(this.packageType != 'REGV4Z01'){
        this. getCarfund_Monitor();
      }
  },
  methods : {

    async getCarfund_Monitor(){
      this.loadingMonitor = true;

      var self = this;

      let param = {"x" : "x"}
      const response = await getCarfundMonitor(param);

      if(response.data.carfundMonitor !== null && response.data.carfundMonitor !== undefined){
        this.carfundMonitor = response.data.carfundMonitor;
        this.series = [response.data.carfundMonitor.porsyento];
      } 
      
      this.loadingMonitor = false;
    },



    async getAccountInfo(){
      this.isLoading = true;
      const response = await getAccountInfo();

      if(response.data.summary1 !== null && response.data.summary1 !== undefined){
        this.summary1 = response.data.summary1;
        this.ccode = response.data.ccode;
      } 
      
      this.isLoading = false;
    },
    async showMoreAccountInfo(){
      this.isLoading = true;
      const response = await getMoreAccountInfo();

      if(response.data.summary1 !== null && response.data.summary1 !== undefined){
        this.summary2 = response.data.summary1;
        this.isShowMore = false;
      }

      this.isLoading = false;
      
    },
    async getEDPLANPairCountNow(){
      this.isLoading = true;
      const response = await getEDPLANPairCount();
      console.log(response.data);

      if(response.data.edplanpairs !== null && response.data.edplanpairs !== undefined){
        this.edplanpairs = response.data.edplanpairs;
        this.maxUturn = response.data.maxUturn;
      }

      this.isLoading = false;
    },
    async getPT(){
       this.pt = String(localStorage.getItem("pt"));
    },
  },
  setup() {

    const baseColor = getCSSVariableValue("--bs-primary");
    const lightColor = getCSSVariableValue("--bs-light-primary");
    const labelColor = getCSSVariableValue("--bs-" + "gray-700");


    const chartOptions = {
      chart: {
        fontFamily: "inherit",
        height: 200,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: "65%"
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
              fontWeight: "700"
            },
            value: {
              color: labelColor,
              fontSize: "30px",
              fontWeight: "700",
              offsetY: 12,
              show: true,
              formatter: function(val) {
                return val + "%";
              }
            }
          },
          track: {
            background: lightColor,
            strokeWidth: "100%"
          }
        }
      },
      colors: [baseColor],
      stroke: {
        lineCap: "round"
      },
      labels: ["Progress"]
    };


    return {
      chartOptions
    };
  }
});
